<template lang="pug">
  .component-packet-form
    .row
      .columns.large-4
        template(v-if="localValue.hasOwnProperty('_translatable')" )
          TranslateField(group="entities", :field="localValue._translatable.name", label="Name", :value="localValue.name")
            input.input-group-field(type="text", v-model="localValue.name")
        template(v-else)
          label Name
            input(type='text' v-model='localValue.name')
        label Amount
          input(type="number" v-model="localValue.amount")
      .columns.large-8
        template(v-if="!localValue.hasOwnProperty('_translatable')" )
          label Description
        template(v-else)
          TranslateField(group="entities", :field="localValue._translatable.description", label="Description", :value="localValue.description", :editor="true")
        Editor(v-model="localValue.description")
    .row
      .columns.large-3
        label Minutes
        input(type="number" v-model="localValue.minutes")
      .columns.large-3
        label Distance
        input(type="number" v-model="localValue.distance")
      .columns.large-3
        label Duration
        input(type="number" v-model="localValue.duration")
      .columns.large-3
        label Max Uses
        input(type="number" v-model="localValue.max_uses")
      .columns.large-3
        label Status
        select(v-model="localValue.status")
          option(:value="null") Select status
          option(value="AVAILABLE" ) AVAILABLE
          option(value="UNAVAILABLE") UNAVAILABLE
</template>

<script>
import BaseForm from './BaseForm.vue';
import Editor from "../ui/Editor.vue";
import TranslateField from "../../../pages/backoffice/TranslateField.vue";

export default {
  name: "PacketForm",
  extends: BaseForm,
  components: {TranslateField, BaseForm, Editor},
};
</script>



// WEBPACK FOOTER //
// PacketForm.vue?2192f526